import { Component, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'data-portal',
  template: `
    <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactive($event)"></router-outlet>
    <div [ngStyle]="{ display: showUiView ? 'initial' : 'none' }" class="ui-view v3-bg"></div>
  `,
  styles: [require('./styles/main.scss')],
})
export class AppComponent {
  public showUiView = new BehaviorSubject(true);

  constructor(private injector: Injector) {}

  onActivate() {
    // TODO remove TEMP solution for spinner
    const spinnerModal = this.injector.get('SpinnerModal');
    spinnerModal.deactivateSpinner();
    this.showUiView.next(false);
  }

  onDeactive() {
    this.showUiView.next(true);
  }
}
